import HorizontalLineUi from 'common/components/entities/HorizontalLine/HorizontalLineUi'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React from 'react'

type HorizontalLineProps = {
  entity: HorizontalLineInterface
}

function NewHorizontalLine({ entity }: HorizontalLineProps) {
  return (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <HorizontalLineUi
        id={entity.htmlAttrId}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
      />
    </StyleWrapper>
  )
}
export default NewHorizontalLine
